import { CircularProgress } from 'material-ui/Progress';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CSVLink } from 'react-csv';
import { Field, reduxForm, Form } from 'redux-form';
import Button from 'material-ui/Button';
import { MenuItem } from 'material-ui/Menu';
import Paper from 'material-ui/Paper';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card, { CardContent } from 'material-ui/Card';
import Typography from 'material-ui/Typography';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import getCustomers from '../../actions/getCustomers';
import getCustomerBillingReport from '../../actions/getCustomerBillingReports';
import getCustomerWithLocations from '../../actions/getCustomerWithLocations';
import search from '../../actions/search';
import Layout from '../Layout';
import renderSelectField from '../../helpers/RenderSelectField';
import validationHelper from '../../helpers/ValidationHelper';
import ReactSelect from '../../helpers/ReactSelect';

const styles = ({
  card: {
    display: 'flex',
    boxShadow: 'none',
  },
  content: {
    flex: '1 0 auto',
  },
  paperStyle: {
    width: '30%',
    height: '100%',
    display: 'inline-block',
    margin: 20,
    marginTop: '13vh'
  },
  buttonStyle: {
    marginTop: 10,
    marginBottom: 15
  },
  marginStyle: {
    margin: 8
  },
  textField: {
    width: 300,
  },
  formControl: {
    minWidth: 120,
  },
  headerStyle: {
    position: 'relative',
    width: '100%',
    height: '60px',
    background: '#FFFFFF',
    boxShadow: 'none'
  },
  headerTitleStyle: {
    marginTop: '3%',
    fontSize: '36px',
    fontFamily: 'Roboto'
  }
});

const validate = (values) => {
  const errors = validationHelper.validateRequired(['selectReport', 'reportMonthYear'], values);
  return errors;
};

let isSysAdmin = false;

class ReportManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportFetching: false,
      reportFetched: false,
      fileName: '',
      products: { 'AutoCheck Auctions': 'aca', 'AutoCheck Insurance': 'aci', 'VIN Cross Check': 'vxc' },
      csvData: [],
      selectedReport: '',
      selectedLocation: '',
      selectedReportDate: '',
      displayRunReportButton: false
    };
  }

  componentDidMount() {
    this.props.actions.getCustomersAndLocations(0, null, this.props.data.config, this);
    const usr = this.props.data.person;
    const currentUserLocation = usr.locations.filter(location => location.locationId ===  localStorage.locationId);
    isSysAdmin = usr && usr.locations && (currentUserLocation[0].role.name === 'sysadmin');

    this.props.actions.getCustomerWithLocations(currentUserLocation[0].customerId, this.props.data.config);
  }

  customerSelected = (event) => {
    const selectedCustomer = event ? event.value : '';

    if (selectedCustomer && selectedCustomer !== 'Please wait...' && selectedCustomer !== 'All Customers') {
      this.props.actions.getCustomerWithLocations(selectedCustomer, this.props.data.config);
    }

    const selectedLocation = this.props.data.customers.customers.customers.filter((customer) => {
      let locationId = '';
      if (customer.customerId === selectedCustomer) {
        locationId = customer.primaryLocationId;
      }
      return locationId;
    })[0].primaryLocationId;

    this.setState({ selectedCustomer, selectedLocation });
  };

  getCustomerBillingReport = (formData) => {
    const event = {
      ...formData,
      selectedCustomer: this.state.selectedCustomer,
      selectedLocation: this.state.selectedLocation
    };

    const loginUser = this.props.data.login.login.username;
    const month = this.state.selectedReportDate.split('-')[0];
    const year = this.state.selectedReportDate.split('-')[1];
    const customer = event.selectedCustomer;
    const location = event.selectedLocation;

    const params = {
      customerId: customer,
      reportDate: `${month}-${year}`,
      requestuserId: loginUser,
      reportType: event.report
    };

    if (this.state.selectedReport === 'InvoiceDetail') params.locationId = location;

    this.props.actions.getCustomerReports(params, this.props.data.config, this);
  }

  handleSave = (formData) => {
    const event = {
      ...formData,
      selectedCustomer: this.state.selectedCustomer,
      selectedLocation: this.state.selectedLocation,
    };

    let params = {};

    const loginUser = this.props.data.login.login.username;
    if (isSysAdmin) {
      if (event.selectedCustomer !== '-1') {
        params = (event.selectedLocation) ?
          {
            locationId: event.selectedLocation,
            customerId: event.selectedCustomer,
            month: this.state.selectedReportDate.split('-')[0],
            year: this.state.selectedReportDate.split('-')[1],
            requestuserId: loginUser
          } :
          {
            customerId: event.selectedCustomer,
            month: this.state.selectedReportDate.split('-')[0],
            year: this.state.selectedReportDate.split('-')[1],
            requestuserId: loginUser
          };
      }
    } else {
      params = event.report.includes('Location') ?
        {
          locationId: localStorage.getItem('locationId'),
          month: this.state.selectedReportDate.split('-')[0],
          year: this.state.selectedReportDate.split('-')[1],
          customerId: this.props.data.locations.data.find(location => location.locationId === localStorage.getItem('locationId')).customerId,
          requestuserId: loginUser
        } :
        {
          customerId: this.props.data.locations.data.find(location => location.locationId === localStorage.getItem('locationId')).customerId,
          month: this.state.selectedReportDate.split('-')[0],
          year: this.state.selectedReportDate.split('-')[1],
          requestuserId: loginUser
        };
    }

    this.setState({ displayRunReportButton: false });
  };

  handleSelectChange = (event) => {
    this.setState({
      reportFetching: false,
      reportFetched: false,
      fileName: '',
      csvData: [],
      selectedReport: event.target.value
    });
  };

  handleSelectDateChange = (event) => {
    this.setState({
      selectedReportDate: event.target.value
    });
  };

  handleReportClick = () => {
    this.setState({ displayRunReportButton: true });
  };

  downloadFile = (csvUrl, count) => {
    setTimeout(() => {
      const elem = window.document.createElement('a');
      elem.href = csvUrl;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    }, count);
  }


  render() {
    let progress;
    const { classes, handleSubmit } = this.props;
    const { csvData, products } = this.state;
    const { customers } = this.props.data;
    const billingSummaryId = 'BillingSummary';
    const invoiceDetailId = 'InvoiceDetail';
    const vinCountId = 'VINCount';
    const pdfReports = [
      vinCountId + ' by Customer',
      vinCountId + ' Report by Location',
      vinCountId,
      billingSummaryId + ' by Customer',
      billingSummaryId + ' by Location',
      billingSummaryId,
      'Executive Report Type Billing Summary Report'
    ];

    if (products[sessionStorage.getItem('product')] === 'aca') { pdfReports.pop(); }

    let reportTypeList;
    if (isSysAdmin) {
      reportTypeList = [
        { id: billingSummaryId, type: 'Billing Summary Report' },
        { id: invoiceDetailId, type: 'Invoice Detail Report' },
        { id: vinCountId, type: 'VIN Count Report' },
        { id: 'Executive Report Type Billing Summary Report', type: 'Executive Report Type Billing Summary Report' },
        { id: 'Sales Tax Report', type: 'Sales Tax Report' }
      ];
    } else if (products[sessionStorage.getItem('product')] === 'aca') {
      reportTypeList = [
        { id: billingSummaryId, type: 'Billing Summary Report' },
        { id: invoiceDetailId, type: 'Invoice Detail Report' },
        { id: vinCountId, type: 'VIN Count Report' },
      ];
    } else {
      reportTypeList = [
        { id: 'Billing Summary Report by Customer', type: 'Billing Summary Report by Customer' },
        { id: 'Billing Summary Report by Location', type: 'Billing Summary Report by Location' },
        { id: 'Invoice Detail Report by Customer', type: 'Invoice Detail Report by Customer' },
        { id: 'Invoice Detail Report by Location', type: 'Invoice Detail Report by Location' },
        { id: 'VIN Count Report by Customer', type: 'VIN Count Report by Customer' },
        { id: 'VIN Count Report by Location', type: 'VIN Count Report by Location' }
      ];
    }

    const reportList = reportTypeList.map((reportType) => {
      const excludedReports = ['Executive Report Type Billing Summary Report',
      'Sales Tax Report'];
      if (!excludedReports.includes(reportType.id)) {
        return (
        <MenuItem
          value={reportType.id}
          key={reportType.id}
        >
          {reportType.type}
        </MenuItem>);
      }
    });

    const CreateReportPeriodDateList = () => {
      const currentDate = new Date();
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
        'September', 'October', 'November', 'December'];
      const monthYearList = [];

      let i = 3;
      if (products[sessionStorage.getItem('product')] === 'aca') {
        i = 6;
      }

      for (i; i > 0; i--) {
        let monthNum = currentDate.getMonth() - i;
        let yearNum = currentDate.getFullYear();

        if (monthNum < 0) {
          monthNum = 12 - Math.abs(monthNum);
          yearNum--;
        }

        const monthInfo = {
          monthYearVal: `${Number(monthNum + 1).toString()}-${yearNum.toString()}`,
          monthYear: `${months[monthNum]} ${yearNum.toString()}`
        };

        monthYearList.unshift(monthInfo);
      }

      return monthYearList;
    };

    const monthYears = CreateReportPeriodDateList().map(monthInfo => (
      <MenuItem
        value={monthInfo.monthYearVal}
        key={monthInfo.monthYearVal}
      >
        {monthInfo.monthYear}
      </MenuItem>));

    let select = (
      <Field
        name="report"
        component={renderSelectField}
        label="Select a Report"
        className={classes.textField}
        divClassName={classes.formControl}
        onChange={this.handleSelectChange}
      >
        {reportList}
      </Field>
    );

    let customerOptions = [
      { key: '-1', value: 'Please wait...', label: 'Please wait...' }
    ];
    if (!this.props.data.customers.fetching && this.props.data.customers.fetched) {
      customers.customers.customers.sort((a, b) => {
        if (a.name > b.name) {
          return 1;
        }
        if (a.name < b.name) {
          return -1;
        }
        return 0;
      });
      if (products[sessionStorage.getItem('product')] === 'aci') {
        customerOptions = [
          { key: '-1', value: 'All Customers', label: 'All Customers' }
        ];
      } else {
        customerOptions = [];
      }

      customers.customers.customers
          .filter(customer => (
              customer.product
              && customer.product.includes(products[sessionStorage.getItem('product')]))
              || (!customer.product && products[sessionStorage.getItem('product')] === 'aci'))
          .forEach((customer) => {
            customerOptions.push({
              key: customer.customerId,
              value: customer.customerId,
              label: customer.name,
        });
      });
    }

    const { customerLocations } = this.props.data.customerLocations;
    const locationOptions = [{ value: '-1', key: '-1', label: 'All Locations' }];
    if (customerLocations && Array.isArray(customerLocations.locations)) {
      customerLocations.locations.forEach((location) => {
        locationOptions.push({
          value: location.locationId,
          key: location.locationId,
          label: location.locationName
        });
      });
    }

    progress = <Button variant="raised" color="primary" type="submit">Submit</Button>;

    if (this.state.displayRunReportButton) {
      progress = <Button variant="raised" color="primary" type="submit">Submit</Button>;
    } else if (this.state.reportFetching) {
      progress = <div align="center"><CircularProgress size={75} /></div>;
      select = (
        <Field
          name="report"
          component={renderSelectField}
          label="Select a Report"
          className={classes.textField}
          divClassName={classes.formControl}
          disabled
        >
          {reportList}
        </Field>);
    } else if (this.state.reportFetched) {
      const bstyle = {
        width: '125px',
        color: '#FFF',
        fontSize: '11px',
        background: '#002053',
        textTranform: 'capitalize'
      };

      progress = (
        <CSVLink
          data={csvData}
          filename={this.state.fileName}
          style={{ color: 'white' }}
        >
          <Button variant="raised" color="primary" type="button" style={bstyle} onClick={this.handleReportClick}>
            Click here to download
          </Button>
        </CSVLink>);
    }

    const locationSelector = (
      <div>
        <Card className={classes.card}>
          <CardContent className={classes.content}>
            <ReactSelect
              name="selectedLocation"
              label="Select a Location"
              placeholder="Select a Location"
              options={locationOptions}
              onChange={event => this.setState({ selectedLocation: event ? event.value : '' })}
              value={this.state.selectedLocation}
              style={{ width: 300, backgroundColor: 'transparent', cursor: 'pointer' }}
            />
          </CardContent>
        </Card>
      </div>
    );

    return (
      <Layout
        className="App"
        showMenu
        menuTitle="Reporting"
        leftTitle="Report Manager"
        rightTitle="Submit File"
        toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727."
      >
        <Paper className={classes.paperStyle}>
          <AppBar position="static" className={classes.headerStyle}>
            <Toolbar className={classes.headerTitleStyle}>
              <Typography variant="title">
                Monthly Reports
              </Typography>
            </Toolbar>
          </AppBar>
          <Form onSubmit={handleSubmit(this.getCustomerBillingReport)}>
            <Card className={classes.card}>
              <CardContent className={classes.content}>
                {select}
              </CardContent>
            </Card>
            {this.state.selectedReport && this.state.selectedReport !== 'Executive Report Type Billing Summary Report' &&
              <Card className={classes.card}>
                <CardContent className={classes.content}>
                  <Field
                    name="reportMonthYear"
                    component={renderSelectField}
                    label="Select a Reporting Period"
                    className={classes.textField}
                    divClassName={classes.formControl}
                    onChange={this.handleSelectDateChange}
                  >
                    {monthYears}
                  </Field>
                </CardContent>
              </Card>
            }
            {
              isSysAdmin &&
              <div>
                <Card className={classes.card}>
                  <CardContent className={classes.content}>
                    <ReactSelect
                        name="selectedCustomer"
                        label="Select a Customer"
                        placeholder="Select a Customer"
                        options={customerOptions}
                        onChange={this.customerSelected}
                        value={this.state.selectedCustomer}
                        style={{ width: 300, backgroundColor: 'transparent', cursor: 'pointer' }}
                    />
                  </CardContent>
                </Card>
              </div>
            }
            {
              this.state.selectedReport !== 'Executive Report Type Billing Summary Report' && this.state.selectedReport !== 'Sales Tax Report' && products[sessionStorage.getItem('product')] !== 'aca' &&
              locationSelector
            }
            <div className={classes.buttonStyle}>
              {progress}
            </div>
          </Form>
        </Paper>
      </Layout>
    );
  }
}

ReportManager.propTypes = {
  classes: PropTypes.shape().isRequired
};

const mapStateToProps = state => ({
  data: {
    userLocations: state.userLocations,
    config: state.config.config,
    customers: state.customers,
    customerLocations: state.customerLocations,
    person: state.person.person,
    locations: state.search.locations,
    login: state.login
  }
});

const mapDispatchToProps = dispatch => ({
  actions: {
    getCustomerReports: (params, config, self) => {
      if (!params.customerId) { params.customerId = ''; }
      self.setState({ reportFetching: true });
      dispatch(getCustomerBillingReport(config, params)).then((response) => {
        if (response.action.type === 'BILLING_PRESIGNED_URL_FETCH_FULFILLED') {
          self.setState({
            reportFetching: false
          });
          if (response.action.payload.data && response.action.payload.data.length > 0) {
            let count = 1000;
            response.action.payload.data.map((csvUrl) => {
              self.downloadFile(csvUrl, count);
              count += 1000;
            });
          }
        }
      }).catch((error) => {
        console.log(error);
        self.setState({ reportFetching: false });
      });
    },
    getCustomerWithLocations: (customerId, config) => {
      dispatch(getCustomerWithLocations(customerId, config));
    },
    getCustomersAndLocations: (pageSize, key, config, self) => {
      dispatch(getCustomers(config)).then(() => {
        dispatch(search('locations', pageSize, key, config));
      });
    }
  }
});

const ReduxForm = withStyles(styles, { withTheme: true })(reduxForm({
  form: 'ReportManagerForm',
  validate
})(ReportManager));

const ConnectedReportManager = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReduxForm);

export default ConnectedReportManager;



// WEBPACK FOOTER //
// ./src/components/Account/ReportManager.js